var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('login-menu'),_c('mainnav'),_c('transition',{attrs:{"name":"router-anim","enter-active-class":"animated fadein","leave-active-class":"animated fadeOut"}},[_c('router-view')],1),_c('contactform'),_c('mfooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }